import { combineReducers } from 'redux';

import { RegisterAction } from '../types';
import {
  registerRequest,
  registerSuccess,
  registerFail,
} from '../actions';

const loading = (state = false, action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
      return true;

    case registerSuccess.type:
    case registerFail.type:
      return false;

    default:
      return state;
  }
};

const error = (state: string | null = null, action: RegisterAction) => {
  switch (action.type) {
    case registerRequest.type:
    case registerSuccess.type:
      return null;

    case registerFail.type:
      return action.payload.message;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  error,
});
